export default "__VITE_ASSET__BnugNdwZ__";